<template>
  <base-section id="products">
    <v-container>
      <v-row>
        <v-col
          cols="1"
          class="text-center hidden-sm-and-down"
        >
          <template v-for="(card, i) in cards">
            <a
              :key="card.title"
              style="color: black"
              @click="button(i)"
            >
              <base-avatar-card
                :key="card.title"
                align="center"
                v-bind="card"
                :color="selectedIndex === i ? 'primary' : ''"
                :dark="selectedIndex === i"
              />
            </a>
            <v-divider
              v-if="i + 1 !== cards.length"
              :key="`divider-${i}`"
              class="my-8"
            />
          </template>
        </v-col>

        <v-col
          cols="2"
          class="hidden-sm-and-down text-center"
        >
          <v-responsive
            height="calc(100% - 16px)"
            class="mt-2"
          >
            <v-divider vertical />
          </v-responsive>
        </v-col>

        <v-col
          cols="12"
          md="9"
        >
          <div v-if="selectedIndex === 0">
            <base-subheading
              size="display-1"
              title="HEQLOAN"
              space="0"
            />

            <base-title
              class="primary--text"
              title="FEATURES"
              tag="div"
            />

            <base-body>
              <v-list dense>
                <v-list-item-group>
                  <v-list-item
                    :inactive="true"
                  >
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>1<sup>st</sup> position mortgage loan with the ability to skip payments for up to 60 <a
                        v-scroll-to="{
                          el: '#sup_a',
                          offset: -160
                        }"
                        href="#"
                      ><sup>a</sup></a> months with Heq PaymentBank <a
                        v-scroll-to="{
                          el: '#sup_c',
                          offset: -160
                        }"
                        href="#"
                      ><sup>c</sup></a></span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      30 year term
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>2% fixed interest rate<a
                        v-scroll-to="{
                          el: '#sup_d',
                          offset: -160
                        }"
                        href="#"
                      ><sup>d</sup></a></span>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Acts as a line of credit for the first 5 years at which point the draw period ends and the remaining
                      balance is amortized over a 25 year payoff
                    </v-list-item-content>
                  </v-list-item> -->
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Monthly payment amount after the skip payment period ends is determined by taking the outstanding
                      principle balance and amortizing it over the remaining term of the loan
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>80% max ltv <a
                        v-scroll-to="{
                          el: '#sup_e',
                          offset: -160
                        }"
                        href="#"
                      ><sup>e</sup></a> base loan amount before adding prepaid interest <a
                        v-scroll-to="{
                          el: '#sup_b',
                          offset: -160
                        }"
                        href="#"
                      ><sup>b</sup></a> for skipping payments <a
                        v-scroll-to="{
                          el: '#sup_a',
                          offset: -160
                        }"
                        href="#"
                      ><sup>a</sup></a> and
                        closing costs</span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Best for long term pay down of a loan over time
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Available for most properties including SFR, Condo, Town Home, 1 to 4 unit residential
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>Available for most occupancy types including Owner Occupied, 2<sup>nd</sup> home, and investment property</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>

              <div id="sup_a" />
              <sup>a</sup>
              Depending on the term selected to skip payments (1 to 5 years in 1 year increments), the interest for
              that period is rolled into the loan when the loan is initially opened and is nonrefundable. Additional
              interest charges and the regular amortization of the loan will not start until the period selected to skip
              payments ends. For example if your current principle balance was $300k and you wanted to have the
              option of skipping payments for 5 years, without rolling in closing costs your new loan would be $330k.
              That loan amount would remain the same for the next 5 years barring any draws on the line of credit or
              pay down of principle. After the 5 years has expired the loan enters the repayment period, the
              remaining balance of the loan would then be amortized to be paid off over the next 25 years. If the term
              for skipping payments was less than 5 years, any additional draws or pay downs during the initial 5 year
              draw period that happened after the skip payment term had expired would be reflected in the
              amortized monthly payment.

              <br>
              <br>
              <div>
                <sup id="sup_b">b</sup>
                The initial interest rolled into the loan for the skip payment period will be the interest rate times the
                number of years skipped times the maximum loan amount even if the max loan is not withdrawn at the
                time the loan is opened. For example if the max loan limit was $300k and the loan drawn at closing was
                $260k, and the desired skip payment period was 3 years, the initial interest rolled into the loan would be
                2% interest rate x 3 years skipped payments x $300k max loan limit = $18,000.
                <br>
                <br>
              </div>

              <div id="sup_c">
                <sup>c</sup>
                With Heq PaymentBank any time you make a full payment during the skip payment period you get to
                add that payment to your Heq PaymentBank. This means that after the skip payment period has ended
                you can use your “banked” payments in your Heq PaymentBank to skip additional payments. A full
                payment is defined as one payment in a given month or multiple payments over several months during
                the skip payment period, that add up to a fully amortized payment of principle and interest for the max
                loan amount over a 25 year term. The full amount of each of payment made in the skip payment period
                will be applied to the principle amount of the loan. For example if your max loan was $300k and your
                loan amount was $260k, and you had 28 years remaining on the loan, and you made a payment of at
                least $1357, which is $300k amortized over 28 years at 2%, then that payment would count toward
                skipping an additional payment after the skip payment term had ended. That banked payment could
                also be achieved by making several smaller payments in previous months in the skip payment period.
                Once enough money has been paid to equal at least one full monthly payment in the current month and
                a payment is banked then the process of banking starts over from zero to acquire additional banked
                payments. Additionally, one large payment or several large payments in one month totaling more than
                one full monthly payment will be counted as one monthly banked payment. You can only qualify for one
                banked payment per month.
                <br>
                <br>
              </div>

              <div id="sup_d">
                <sup>d</sup>
                The note rate is 2%. The APR (annual percentage rate) will be higher and vary depending on closing
                costs
                <br>
                <br>
              </div>
              <div id="sup_e">
                <sup>e</sup>
                ltv means loan to value. For example if your home’s appraised value was $100k, then the base
                loan amount would be $80k.
              </div>
            </base-body>

            <base-btn
              class="mb-12"
              :to="{name: 'Loan Application'}"
            >
              Apply Now
            </base-btn>
          </div>
          <div v-if="selectedIndex === 1">
            <base-subheading
              size="display-1"
              title="HEQLOC"
              space="0"
            />

            <base-title
              class="primary--text"
              title="FEATURES"
              tag="div"
            />

            <base-body>
              <v-list dense>
                <v-list-item-group>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        1<sup>st</sup> position with the ability to skip payments for up to 60 <a
                          v-scroll-to="{
                            el: '#sup_a',
                            offset: -160
                          }"
                          href="#"
                        ><sup>a</sup></a> months with Heq PaymentBank <a
                          v-scroll-to="{
                            el: '#sup_c',
                            offset: -160
                          }"
                          href="#"
                        ><sup>c</sup></a>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      30 year term
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        2% fixed interest rate <a
                          v-scroll-to="{
                            el: '#sup_heloc_a',
                            offset: -160
                          }"
                          href="#"
                        ><sup>a</sup></a>
                        <!-- for any portion of the balance 80% ltv or less, and 10% on any portion
                        of the balance over 80% ltv <a
                          v-scroll-to="{
                            el: '#sup_heloc_b',
                            offset: -160
                          }"
                          href="#"
                        ><sup>b</sup></a> -->
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Acts as a line of credit for the first 5 years, at which point the draw period ends and the remaining
                      balance is amortized over a 25 year payoff
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Monthly payment amount is determined by taking the outstanding loan amount that month and
                      amortizing it over the remaining term of the loan
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        80% max ltv <a
                          v-scroll-to="{
                            el: '#sup_heloc_b',
                            offset: -160
                          }"
                          href="#"
                        ><sup>b</sup></a>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Best for short term use as a traditional line of credit
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Available for most properties including SFR, Condo, Town Home, 1 to 4 unit residential
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>Available for most occupancy types including Owner Occupied, 2<sup>nd</sup> home, and investment property</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>

              <sup id="sup_heloc_a">a</sup> The note rate is 2%. The APR (annual percentage rate) will be higher and vary depending on closing
              costs and ltv.
              <br>
              <br>
              <sup id="sup_heloc_b">b</sup> ltv means loan to value. For example if your home’s appraised value was $100k, then the base loan
              amount would be $90k.

              <br>
              <br>
              <div id="sup_a" />
              <sup>a</sup>
              Depending on the term selected to skip payments (1 to 5 years in 1 year increments), the interest for
              that period is rolled into the loan when the loan is initially opened and is nonrefundable. Additional
              interest charges and the regular amortization of the loan will not start until the period selected to skip
              payments ends. For example if your current principle balance was $300k and you wanted to have the
              option of skipping payments for 5 years, without rolling in closing costs your new loan would be $330k.
              That loan amount would remain the same for the next 5 years barring any draws on the line of credit or
              pay down of principle. After the 5 years has expired the loan enters the repayment period, the
              remaining balance of the loan would then be amortized to be paid off over the next 25 years. If the term
              for skipping payments was less than 5 years, any additional draws or pay downs during the initial 5 year
              draw period that happened after the skip payment term had expired would be reflected in the
              amortized monthly payment.

              <br>
              <br>
              <div>
                <sup id="sup_b">b</sup>
                The initial interest rolled into the loan for the skip payment period will be the interest rate times the
                number of years skipped times the maximum loan amount even if the max loan is not withdrawn at the
                time the loan is opened. For example if the max loan limit was $300k and the loan drawn at closing was
                $260k, and the desired skip payment period was 3 years, the initial interest rolled into the loan would be
                2% interest rate x 3 years skipped payments x $300k max loan limit = $18,000.
                <br>
                <br>
              </div>

              <div id="sup_c">
                <sup>c</sup>
                With Heq PaymentBank any time you make a full payment during the skip payment period you get to
                add that payment to your Heq PaymentBank. This means that after the skip payment period has ended
                you can use your “banked” payments in your Heq PaymentBank to skip additional payments. A full
                payment is defined as one payment in a given month or multiple payments over several months during
                the skip payment period, that add up to a fully amortized payment of principle and interest for the max
                loan amount over a 25 year term. The full amount of each of payment made in the skip payment period
                will be applied to the principle amount of the loan. For example if your max loan was $300k and your
                loan amount was $260k, and you had 28 years remaining on the loan, and you made a payment of at
                least $1357, which is $300k amortized over 28 years at 2%, then that payment would count toward
                skipping an additional payment after the skip payment term had ended. That banked payment could
                also be achieved by making several smaller payments in previous months in the skip payment period.
                Once enough money has been paid to equal at least one full monthly payment in the current month and
                a payment is banked then the process of banking starts over from zero to acquire additional banked
                payments. Additionally, one large payment or several large payments in one month totaling more than
                one full monthly payment will be counted as one monthly banked payment. You can only qualify for one
                banked payment per month.
                <br>
                <br>
              </div>
            </base-body>

            <base-btn
              class="mb-12"
              :to="{name: 'Loan Application'}"
            >
              Apply Now
            </base-btn>
          </div>

          <div v-if="selectedIndex === 2">
            <base-subheading
              size="display-1"
              title="REVERSE HEQ MORTGAGE"
              space="0"
            />

            <base-title
              class="primary--text"
              title="FEATURES"
              tag="div"
            />

            <base-body>
              <v-list dense>
                <v-list-item-group>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Reverse mortgage for those that are at least 62 years of age.
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        1<sup>st</sup> position HELOC with the ability to skip payments for the duration of the loan <!-- 90% max ltv
                        <a
                          v-scroll-to="{
                            el: '#sup_reverse_b',
                            offset: -160
                          }"
                          href="#"
                        ><sup>b</sup></a> -->
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        2% fixed interest rate
                        <a
                          v-scroll-to="{
                            el: '#sup_reverse_a',
                            offset: -160
                          }"
                          href="#"
                        ><sup>a</sup></a>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        Acts as a line of credit for the duration of the loan
                        <a
                          v-scroll-to="{
                            el: '#sup_reverse_c',
                            offset: -160
                          }"
                          href="#"
                        ><sup>c</sup></a>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      <span>
                        70% max ltv
                        <a
                          v-scroll-to="{
                            el: '#sup_reverse_b',
                            offset: -160
                          }"
                          href="#"
                        ><sup>b</sup></a> base loan amount before adding prepaid interest for skipping payments
                        <a
                          v-scroll-to="{
                            el: '#sup_reverse_a',
                            offset: -160
                          }"
                          href="#"
                        ><sup>a</sup></a>
                        and closing
                        costs.
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Available for most properties including SFR, Condo, Town Home, 1 to 4 unit residential.
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item :inactive="true">
                    <v-icon>
                      mdi-circle-small
                    </v-icon>
                    <v-list-item-content>
                      Available owner occupied properties
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>

              <sup id="sup_reverse_a">a</sup>The note rate is 2%. The APR (annual percentage rate) will be higher and vary depending on closing
              costs. Interest is prepaid and added to the loan in 5 year increments and is nonrefundable. For example,
              10% interest is added to the loan for the first 5 years at initial closing and then at the 5, 10, 15, 20, 25,
              etc, anniversaries of the loan an additional 10% is added at each anniversary for each subsequent 5
              years of interest.
              <br>
              <br>
              <sup id="sup_reverse_b">b</sup>ltv means loan to value. For example if your home’s appraised value was $100k, then the base loan
              amount would be $70k.
              <br>
              <br>
              <sup id="sup_reverse_c">c</sup>Duration of the loan. Loan becomes due when one of two things happen, either the borrower no
              longer occupies the property as their primary residence or they become deceased. The heirs to the
              borrower will have the opportunity to sell the property, refinance, or let the property go to Heq.
            </base-body>

            <base-btn
              class="mb-12"
              :to="{name: 'Loan Application'}"
            >
              Apply Now
            </base-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import BaseAvatarCard from '@/components/base/AvatarCard'
  export default {
    name: 'SectionProducts',
    components: { BaseAvatarCard },
    data: () => ({
      selectedIndex: 0,
      cards: [
        {
          title: 'HEQLOAN',
          icon: 'mdi-castle',
          features: [
            'Search Engine optimization',
            'Virtual Products',
            'Content Management',
            'Virtual Products',
            'Keyword Analysis',
            'Content Management',
          ],
        },
        {
          title: 'HEQLOC',
          icon: 'mdi-home-modern',
          features: [
            'Search Engine optimization',
            'Virtual Products',

          ],
        },
        {
          title: 'Reverse HEQ Mortgage',
          icon: 'mdi-rotate-orbit',
          features: [
            'Search Engine optimization',
            'Virtual Products',
          ],
        },
      ],
    }),
    computed: {
      selectedCard () {
        return this.cards[this.selectedIndex]
      },
    },

    methods: {
      button (i) {
        this.selectedIndex = i
      },
    },
  }
</script>
